import { isNumber } from 'lodash';
import createSource from './createSource';
import {
  SOURCE_ROLE_SPEAKER,
  CAMERA_PRESENTER
} from '@studio/constants/Sources';
import { selectLastPresenterSource } from 'selectors/broadcastSourcesSelector';
import { UNASSIGNED } from 'utils/broadcastSourceHelper';

export default number => {
  const title = 'Speaker';

  return (dispatch, getState) => {
    const state = getState();
    let { order: lastCameraPresenterOrder = 0 } =
      selectLastPresenterSource(state);

    const order = isNumber(lastCameraPresenterOrder)
      ? lastCameraPresenterOrder + 1
      : 0;

    dispatch(
      createSource({
        title: `${title} ${number}`,
        type: CAMERA_PRESENTER,
        value: UNASSIGNED,
        role: SOURCE_ROLE_SPEAKER,
        order
      })
    );
  };
};
